export const EMAIL_VERIFICATION_SUCCESS = {
    EMAIL_VERIFICATION_SUCCESS_MESSAGE: {
        key: 'EMAIL_VERIFICATION_SUCCESS_MESSAGE',
        value: 'Dear {{userName}}, Your Account is verified successfully. Please click on the button below to proceed to the checkout page to subscribe to the selected plan.'
    },
    EMAIL_VERIFICATION_ERROR_MESSAGE: {
        key: 'EMAIL_VERIFICATION_ERROR_MESSAGE',
        value: 'Dear {{userName}}, the checkout process has failed. Please try again.'
    },
    PROCEED_TO_CHECKOUT_BUTTON: {
        key: 'PROCEED_TO_CHECKOUT_BUTTON',
        value: 'PROCEED TO CHECKOUT'
    },
    EMAIL_VERIFICATION_FAILED_TITLE: {
        key: 'EMAIL_VERIFICATION_FAILED_TITLE',
        value: 'EMAIL VERIFICATION FAILED'
    },
    ERROR_LINK_EXPIRED: {
        key: 'ERROR_LINK_EXPIRED',
        value: 'The link has expired.'
    },
    SOMETHING_WENT_WRONG_ERROR_MESSAGE: {
        key: 'SOMETHING_WENT_WRONG_ERROR_MESSAGE',
        value: 'Ooops! something went wrong'
    }
};